import styled from 'styled-components';

export const Container = styled.div<{ background: string; height: string }>`
    width: 100%;
    height: ${({ height }) => height};
    border-radius: 15px;
    overflow: hidden;
    background-image: ${({ background }) => `url(${background})`};
    background-size: cover;
    background-position: center;
    padding: 15px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    cursor: pointer;
`;

export const TitleContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    height: 18px;
`;

export const Title = styled.span`
    font-size: 14px;
    line-height: 1.2;
    font-weight: 700;
    color: #ffffff;
`;
